import React from "react";
import EvaluationForm from "../../../components/user/evaluation/evaluationManagerForm";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const DetailEvaluationPage = () => {
  let { uuid } = useParams();
  return (
    <Layout
      body={
        <>
          <EvaluationForm uuid={uuid} />
        </>
      }
    />
  );
};

DetailEvaluationPage.propTypes = {};

export default DetailEvaluationPage;
